import { useTranslation } from 'react-i18next';

import clsx from 'clsx';

import styles from './room-description-text.module.scss';

interface IRoomDescriptionTextProps {
  roomDescription: string;
  isMobile?: boolean;
}

export const RoomDescriptionText = ({
  roomDescription,
  isMobile = false,
}: IRoomDescriptionTextProps) => {
  const { t } = useTranslation();

  const roomDescriptionText = roomDescription || t('modals.watchGame.watch');

  return (
    <div
      className={clsx(
        'z-20 bg-grape py-0 text-[#5A6AFF] sm:py-2',
        styles.marqueeWrapper,
        isMobile ? 'leading-[15px]' : 'absolute bottom-0 left-0 right-0',
      )}
    >
      {isMobile ? (
        <div className={styles.marquee}>
          <span>{roomDescriptionText}</span>
        </div>
      ) : (
        <div className={styles.staticText}>
          <span>{roomDescriptionText}</span>
        </div>
      )}
    </div>
  );
};
